let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kWrFZ"), load("2AjeU")]).then(() => parcelRequire('lDRdH'));